import { QuestionBase } from '@app/core/models/question/question-base';

export class RadioQuestion extends QuestionBase<string> {
  controlType = 'radio';
  type: string;
  options: { value: number, checked: boolean, classIcon: string, name: string }[] = [];

  constructor(options: any = {}) {
    super(options);
    this.type = options['type'] || 'radio';
    this.options = options['options'] || [];
  }
}




// WEBPACK FOOTER //
// ./src/app/core/models/question/radio-question.ts